export enum TipoAssinatura {
  SMS = '1',
  EMAIL = '2',
  TOKEN = '3'
}
